export default function getProjects() {
    return [
      {
        img:"",
        id: 1,
        image:'ShopWebsite.png',
        projectTitle: "Shop.com - E-commerece website",
        projectInfo:
         "An E-commerce Website, and also the my first real project.",
        techUsed: ["HTML", "CSS","JavaScript"],
        projectLinkHosted: "https://darling-travesseiro-cc33f2.netlify.app/",
        projectLinkGithub: "https://github.com/mithunsen04/Shop.com_Clone",
      },
      {
        img:"",
        id: 2,
        image:'OnlineCycleStore.png',
        projectTitle: "Specialized- Online Cycle Store",
        projectInfo:
        "It is a web-based application that aims to provide a platform for all the needs of a cycling enthusiasts.",
        techUsed: ["React", "Redux", "JavaScript", "CSS"],
        projectLinkHosted: "https://specializedstore.vercel.app/",
        projectLinkGithub: "https://github.com/ProActive44/specialized-bike-app",
      },
      {
        id: 3,
        projectTitle: "eBay-Ecommerce",
        image:'ebayImg.png',
        projectInfo:"The project includes features such as user registration, product listing, search and filtering, shopping cart, checkout, payment processing, and order tracking.",
        techUsed: ["vanilaJs", "HTML", "CSS"," Json-Server API"],
        projectLinkHosted: "https://dreamy-marigold-b2eb4d.netlify.app/",
        projectLinkGithub: "https://github.com/Imrajsrivastava/ebay-project-2",
      },
      {
        id: 4,
        projectTitle: "Zostel Clone",
        image:"ZostelClone.png",
        projectInfo:
          "It is the cloned version of the now trending website among wanderlusts- Zostel.",
        techUsed: ["React","Redux", "javascript", "CSS"],
        projectLinkHosted: "https://zostelclone-pearl.vercel.app/",
        projectLinkGithub: "https://github.com/Manojkumar7978/zostelclone",
      }
    ];
  }